"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFilters = exports.makeMapStateToProps = exports.getDisplayName = exports.filtersShape = exports.actionCreators = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _nicbaseReducers = require("nicbase-reducers");

var _reselect = require("reselect");

var _excluded = ["filters", "updateFilters"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// selector to get filters merged with initial values
var makeGetFilters = function makeGetFilters(initialValues) {
  return (0, _reselect.createSelector)(function (state, ownProps) {
    return state.filters[ownProps.id];
  }, function (filters) {
    return Object.assign({}, initialValues, filters);
  });
}; // fetch all filters for wrapped component


var makeMapStateToProps = function makeMapStateToProps() {
  var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return {};
  };
  return function (initialState, initialProps) {
    // calculate initial filter values (with state + props + custom logic)
    var initialFilterValues = init(initialState, initialProps);
    var getFilters = makeGetFilters(initialFilterValues);

    var mapStateToProps = function mapStateToProps(state, ownProps) {
      return {
        filters: getFilters(state, ownProps)
      };
    };

    return mapStateToProps;
  };
}; // map the update filters function to props for HOC


exports.makeMapStateToProps = makeMapStateToProps;
var actionCreators = {
  updateFilters: _nicbaseReducers.updateFilters
}; // This method returns the display name of the original wrapped component (used for debug output)

exports.actionCreators = actionCreators;

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}; // wrap a component


exports.getDisplayName = getDisplayName;

var withFilters = function withFilters() {
  var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return {};
  };
  return function (WrappedComponent) {
    var WithFilters = function WithFilters(_ref) {
      var filters = _ref.filters,
          updateFilters = _ref.updateFilters,
          props = _objectWithoutProperties(_ref, _excluded);

      var update = (0, _react.useCallback)(function (values) {
        updateFilters(props.id, values);
      }, [props.id, updateFilters]);
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _objectSpread(_objectSpread({}, props), {}, {
        filters: {
          update: update,
          values: filters
        }
      }));
    };

    WithFilters.displayName = "withFilters(".concat(getDisplayName(WrappedComponent), ")");
    WithFilters.propTypes = {
      id: _propTypes["default"].number.isRequired,
      filters: _propTypes["default"].shape({}),
      updateFilters: _propTypes["default"].func
    };
    WithFilters.defaultProps = {
      filters: {
        values: {}
      },
      updateFilters: function updateFilters() {}
    }; // copy over static functions (if any)

    (0, _hoistNonReactStatics["default"])(WithFilters, WrappedComponent);
    return (0, _reactRedux.connect)(makeMapStateToProps(init), actionCreators)(WithFilters);
  };
};

exports.withFilters = withFilters;

var filtersShape = _propTypes["default"].shape({
  values: _propTypes["default"].shape({}),
  update: _propTypes["default"].func.isRequired
});

exports.filtersShape = filtersShape;